import { Box, styled, Typography } from '@mui/material';

export const EmptyStateWrap = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '280px 32px',
  textAlign: 'center',
});

export const EmptyStateIconCircle = styled(Box)(({ theme }) => ({
  width: '88px',
  height: '88px',
  borderRadius: '50%',
  background: theme.palette.primary.dark,
  border: `8px solid ${theme.palette.primary.light}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.primary.main,
  svg: {
    width: '36px',
    height: '36px',
  },
  'svg path': {
    fill: 'currentColor',
  },
}));

export const EmptyStateTitle = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 600,
  color: theme.palette.secondary.dark,
  marginTop: '24px',
  maxWidth: '420px',
}));

export const EmptyStateLines = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  marginTop: '24px',
});

export const EmptyStateLine = styled(Box, {
  shouldForwardProp: prop => prop !== 'lineWidth',
})<{ lineWidth: number }>(({ lineWidth }) => ({
  width: `${lineWidth}px`,
  height: '8px',
  borderRadius: '4px',
  backgroundColor: '#DBEDE3',
}));
